import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login/login.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private router: Router, private loginService: LoginService) { }
  timer: number = 0;
  id: any;
  resetSession() {
    this.timer = 0;
    clearInterval(this.id);
    this.startSession();
  }

  startSession() {
    this.id = setInterval(() => {
      this.timer++;
      this.onSessionOut();
    }, 1000);

  }
  onSessionOut() {
    if (this.timer > 6000) {
      clearInterval(this.id);
      this.timer = 0;
      this.logout();
    }
  }

  logout() {
    clearInterval(this.id);
    this.timer = 0;
    // this.loginService.logout().subscribe((resdata: any) => {
    localStorage.removeItem('mcmt_userName');
    localStorage.removeItem('mcmt_userId');
    sessionStorage.removeItem('mcmt_token');
    localStorage.removeItem('mcmt_token');
    localStorage.removeItem('mcmt_roleCode');
    sessionStorage.removeItem('mcmt_userId');
    this.router.navigate(['/MCMaterial/Login']);
    clearInterval(this.id);
    this.timer = 0;
    // });

  }
}

